import { MobileRefreshButton } from "./MobileRefreshButton";

// Raftel: top-13 = debajo de la barra global (RaftelLayout)
const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <header className="fixed top-13 left-0 right-0 z-10 bg-secondary h-14 px-4 w-full flex justify-between items-center md:static md:mb-4 md:rounded-lg">
      {children}
      <MobileRefreshButton />
    </header>
  );
};

export default MobileHeader;
